var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenfitBoost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 21.6668V15.0002C36.6666 6.66683 33.3333 3.3335 25 3.3335H15C6.66665 3.3335 3.33331 6.66683 3.33331 15.0002V25.0002C3.33331 33.3335 6.66665 36.6668 15 36.6668H21.6666",
    stroke: "url(#paint0_linear_33_603)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2168 24.1501L16.1835 19.0001C16.7501 18.2668 17.8001 18.1334 18.5335 18.7001L21.5835 21.1001C22.3168 21.6668 23.3668 21.5334 23.9335 20.8168L27.7835 15.8501",
    stroke: "url(#paint1_linear_33_603)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4667 26.3669L32.9334 27.3169C33.1667 27.7835 33.75 28.2169 34.2667 28.3169L34.9 28.4169C36.8 28.7336 37.25 30.1336 35.8833 31.5169L35.3 32.1002C34.9167 32.5002 34.7 33.2669 34.8167 33.8002L34.9 34.1502C35.4167 36.4502 34.2 37.3335 32.2 36.1335L31.7667 35.8835C31.25 35.5835 30.4167 35.5835 29.9 35.8835L29.4667 36.1335C27.45 37.3502 26.2333 36.4502 26.7667 34.1502L26.85 33.8002C26.9666 33.2669 26.75 32.5002 26.3667 32.1002L25.7833 31.5169C24.4167 30.1336 24.8667 28.7336 26.7667 28.4169L27.4 28.3169C27.9 28.2336 28.5 27.7835 28.7333 27.3169L29.2 26.3669C30.1 24.5502 31.5667 24.5502 32.4667 26.3669Z",
    stroke: "url(#paint2_linear_33_603)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_603",
    x1: 20,
    y1: 3.3335,
    x2: 20,
    y2: 36.6668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_603",
    x1: 20.0002,
    y1: 15.8501,
    x2: 20.0002,
    y2: 24.1501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_603",
    x1: 30.8333,
    y1: 25.0044,
    x2: 30.8333,
    y2: 36.6764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53A6FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenfitBoost);
export default __webpack_public_path__ + "static/media/benfit-boost.1dc258b290810f41f72f6492da4ab798.svg";
export { ForwardRef as ReactComponent };